import React, {useState, useRef, Fragment, useEffect} from 'react';
import {MapCircularSelection, Chip_input, Popup, List, Select, MultipleSelect, CSV_component, Explanation_text, SearchPart} from '../../../../components';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import WorkIcon from '@material-ui/icons/Work';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import ExtensionIcon from '@material-ui/icons/Extension';
import SearchIcon from '@material-ui/icons/Search';
import { FieldArray } from 'react-final-form-arrays';
import { Form, Field } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import PublicIcon from '@material-ui/icons/Public';
import DeleteIcon from '@material-ui/icons/Delete';
import ImageIcon from '@material-ui/icons/Image';
import CancelIcon from '@material-ui/icons/Cancel';
import Auto_search from './Auto_search';
import AddressSection from '../../../../components/FormSections/Fields/AddressSection'
import DescriptionSection from '../../../../components/FormSections/Fields/DescriptionSection'
import ExtraUrlsSection from '../../../../components/FormSections/Fields/ExtraUrlsSection'
import CustomFieldsSection from '../../../../components/FormSections/Fields/CustomFieldsSection'
import CustomDecisionsSection from '../../../../components/FormSections/Fields/CompanyDecisionsSection';
import SelectListSection from '../../../../components/FormSections/Fields/SelectListSection';
import {connect} from 'react-redux';

function Add_popup(props){
  const[refresh, setRefresh]=useState(0);
  const[automated_error, setAutomatedError]=useState(false);
  const[list_done, setListDone]=useState(false);
  const[open_section, setOpenSection]=useState(undefined);
  const[list_error, setListError]=useState(false);
  const[type, setType]=useState((isScoringAccount(props.workspace))?'upload_csv':undefined);
  const[update_duplicates, setUpdateDuplicates]=useState(false);
  const[csv_uploaded, setCsvUploaded]=useState(false);
  //const[multiple_prefixes, setMultiplePrefixes]=useState(false);
  let map_processed=useRef(false);
  let first_time_data=useRef(true);
  let setCsvData=useRef(undefined);
  let preview_search=useRef(true);
  let last_search_message=useRef(false);
  let initial_values=useRef(undefined);
  let getMapData=useRef(undefined);
  let paying_customer=false;
  if(props.workspace!=undefined && props.workspace.active_subscription!=undefined && props.workspace.active_subscription.free_trial!=true){paying_customer=true;}

  if(window.location.href.includes('open_popup=true')){
    useEffect(()=>{
      setType((window.location.href.includes('add_type=upload_csv'))?'upload_csv':'automated_search');
    },[])
  }

  useEffect(()=>{
    props.resetDuplicateData();
  },[])

  let lists=[{id:'new', name:'New'}];
  if(props.lists!=undefined){for(let key in props.lists){lists.push({id:key, name:props.lists[key].name});}}




    function onSubmit(params){
      console.log(params, 'PARAMS', list_done, last_search_message);
      let block_close=false;
      if((map_processed.current==true || type!='automated_search') && (params.list_id=='new' && params.list_name==undefined)){setListError(true);}else{
      if(type=='automated_search'){
        if(map_processed.current==false){
          let map_data=getMapData.current(true);
          if(map_data!='block'){
            map_processed.current=true;
          }
          block_close=true;
          setRefresh(refresh+1);
          console.log('MAP PROCESSED');
        }else if(last_search_message.current==false){// || (params.search_country=='' || params.search_country==undefined)
          //let prefixes=[]; if(params.prefixes!=undefined && multiple_prefixes==true){for(let p of params.prefixes){prefixes.push(p.prefix);}}else{prefixes=undefined;}
          //let search=''; if(params.search_business_type!=undefined && prefixes==undefined){search+=' '+params.search_business_type;} if(params.search_city!=undefined || params.search_region!=undefined || params.search_country!=undefined){search+=' in ';} if(params.search_city!=undefined){search+=' '+params.search_city;} if(params.search_region!=undefined){search+=' '+params.search_region;} if(params.search_country!=undefined){search+=' '+params.search_country;}
          let map_data=getMapData.current(true);
          console.log(map_data, 'MAP DATA');
          props.automatedSearch({
            include_nearby:map_data.include_nearby,
            only_websites:map_data.only_websites,
            search:map_data.business_type,
            center_longitude:map_data.center_longitude,
            center_latitude:map_data.center_latitude,
            side_length_metres:map_data.side_length_metres,
            square:JSON.stringify(map_data.square),
            business_type:params.search_business_type,
            list_id:(params.list_id=='new')?undefined:params.list_id,
            list_name:params.list_name,
            max_results:map_data.max_results
          });
          //if(preview_search.current==false){
          block_close=true;
          last_search_message.current=true;
        //  }
      }}else if(type=='upload_csv'){
        if(params.list_id=='new' && params.list_name==undefined){}else{
        let error=setCsvData.current(params);
        block_close=true;
        }
      }else if(type=='single'){
        let new_params={origin:'MANUAL'};
        for(let key in params){
          if(key=='company_urls'){let new_company_urls=[]; for(let u of params[key]){new_company_urls.push(u.url);} new_params.company_urls=new_company_urls;}
          else if(key=='company_fields'){for(let k in params[key]){if(Array.isArray(params[key][k].value)==true){params[key][k].value=JSON.stringify(params[key][k].value);}}}
          else if(key.includes('company_decision_') && params[key]!==''){if(new_params.company_decisions==undefined){new_params.company_decisions=[];} new_params.company_decisions.push({value:params[key], workspace_decision_id:key.replace('company_decision_', '')});}
          else{new_params[key]=params[key];}}
          new_params.company_fields=params.company_fields;
        if(new_params.list_id=='new'){delete new_params.list_id;}
        props.createCompany(new_params);
      }
      if(block_close==false){props.onClose();}
    }}

    //function getParsecsvdata(data) {let parsedata = []; let newLinebrk = data.replace(/(\r\n)|\r|\n/g, '\n').split(/\n+/g); for(let i = 0; i < newLinebrk.length; i++) {parsedata.push(newLinebrk[i].split(","))} setCsvData(parsedata);}

    let owners=[];

    if(props.workspace!=undefined){let us=props.workspace.user_workspaces; for(let key in us){owners.push({id:us[key].id, name:us[key].first_name+' '+us[key].last_name})}}

    function scrollToBottom(){
      let outer_div=document.getElementById('outer_scroll');
      outer_div.scrollTop=outer_div.scrollHeight;
      let div=document.getElementById('scroll_cols');
      div.scrollTop=div.scrollHeight;
    }
    let default_search={};
    if(props.workspace!=undefined && props.me!=undefined){
      for(let uw_key in props.workspace.user_workspaces){let uw=props.workspace.user_workspaces[uw_key]; if(uw.user_id==props.me.id){if(uw.search_defaults!=undefined){default_search=JSON.parse(uw.search_defaults);}}}
      let prefixes=[]; let index=0; if(default_search.prefixes!=undefined){for(let p of default_search.prefixes){prefixes.push({id:index, prefix:p}); index+=1;}}
      if(initial_values.current==undefined){initial_values.current={company_urls:[], prefixes:prefixes, search_country:default_search.country, search_region:default_search.region, search_business_type:default_search.business_type, list_id:(props.list!=undefined)?props.list.id:'new', list_name:(props.workspace!=undefined && isScoringAccount(props.workspace)==true)?'Upload list':undefined}}
    }
    // {type:'automated_search', main_text:'Import from Google Maps', icon:<img src='/images/icons/google_maps.png' style={{width:'50px'}}/>}
    console.log(props, 'AZERTY');
    return(
      <div>
      <Form
        onSubmit={onSubmit}
        initialValues={initial_values.current}
        mutators={{
          ...arrayMutators
        }}
      >
        {form_props => (
          <form onSubmit={form_props.handleSubmit}>
          <Popup submit_button no_close always_open icon={(type=='automated_search')?<PublicIcon color='secondary'/>:null} title={(type=='automated_search')?'Company search':(type=='upload_csv')?'Upload prospects':'prospect_create_popup_title'}  accept_button_click={()=>{if(last_search_message.current==true){last_search_message.current=false; props.onClose();}else if(props.companies_batch_count!=undefined && props.duplicates_batch_count==undefined){props.onClose();}else if(props.duplicates_batch_count!=undefined){props.dealWithDuplicates({prospect_batch_id:props.prospect_batch_id, update_duplicates:update_duplicates})}else{if(paying_customer==true){preview_search.current=false;}else{preview_search.current=true;}; form_props.form.submit();}}} content={
              <div style={{width:'600px', position:'relative', height:(csv_uploaded)?'calc(100vh - 155px)':(type=='automated_search')?'calc(100vh - 245px)':'calc(100vh - 215px)', minHeight:'300px'}}>{(type==undefined)?<List onClick={(x)=>{setType(x.type);}} list_data={
                [
                  {type:'single', main_text:'Single', icon:<AddIcon color='primary'/>},
                  {type:'upload_csv', main_text:'Upload csv', icon:<CloudUploadIcon color='primary'/>},
                  {type:'automated_search', main_text:'Company search', icon:<PublicIcon color='secondary'/>}
                ]} />
                    :(type=='single')?
                    <Grid container style={{marginTop:'20px', marginBottom:'20px', marginLeft:'20px', width:'calc(100% - 40px)'}}>
                      <SelectListSection list_error={list_error} {...props}/>
                      <Grid item xs={6} sm={4}><Select size='small' variant='outlined' title='prospect_owner_label' name='user_workspace_id'style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'10px', backgroundColor:'#f7f9fc'}} select_data={owners}/></Grid>
                      <Grid item xs={6} sm={4}><Field name='name'>{(f)=><TextField size='small' variant='outlined' label='Company' value={f.input.value} onChange={f.input.onChange} style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'10px', backgroundColor:'#f7f9fc'}} />}</Field></Grid>
                      <Grid item xs={6} sm={4}><Select title='prospect_status_label' name='status' style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'10px', backgroundColor:'#f7f9fc'}}  enum='status'/></Grid>
                      <Grid item xs={6} sm={4}><Field name='website'>{(f)=><TextField size='small' variant='outlined' label='Website' value={f.input.value} onChange={f.input.onChange} style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'10px', backgroundColor:'#f7f9fc'}} />}</Field></Grid>

                      <AddressSection {...props} countries={props.select_countries} open_section={open_section} setOpenSection={setOpenSection}/>
                      <DescriptionSection {...props} open_section={open_section} setOpenSection={setOpenSection}/>
                      <ExtraUrlsSection {...props} icons={props.url_icons} conv={props.url_conv} type="COMPANY" open_section={open_section} setOpenSection={setOpenSection}/>
                      <CustomFieldsSection {...props} open_section={open_section} setOpenSection={setOpenSection} type="COMPANY"/>
                      <CustomDecisionsSection {...props} open_section={open_section} setOpenSection={setOpenSection}/>
                    </Grid>
                    :(type=='upload_csv')?<div style={{marginTop:(csv_uploaded==true)?'-60px':'0px', height:'100%', position:'relative'}}><CSV_component {...props} map_height="calc(100% - 180px)" hide_column_map={(csv_uploaded==true)?false:true} setCsvData={(d)=>{setCsvUploaded(true);}} update_duplicates={update_duplicates} setUpdateDuplicates={setUpdateDuplicates} list_error={list_error} select_list completedUpload={()=>{}} setComposeBatch={(func)=>{setCsvData.current=func;}}/></div>
                    :(type=='suppliers')?<div></div>
                    :(type=='automated_search')?<Auto_search {...props} credits_data={undefined} automated_error={automated_error} list_error={list_error} setListDone={setListDone} last_search_message={last_search_message} map_processed={map_processed} getMapData={getMapData} returnResults={(func)=>{getMapData.current=func}}/>
                    :null
              }
              </div>} closed={()=>{props.onClose();}} tertiary_accept_button_left tertiary_accept_button={(csv_uploaded==true || (map_processed.current==true && last_search_message.current==false))?'Go back':undefined} tertiary_accept_button_color='secondary'

              tertiary_accept_button_click={(map_processed.current==true)?()=>{map_processed.current=false; setRefresh(refresh+1);}:(csv_uploaded==true)?()=>{setCsvUploaded(false);}:undefined}
               accept_button={(last_search_message.current==true)?'Ok':(props.companies_batch_count!=undefined && props.duplicates_batch_count!=undefined)?'Save':(props.companies_batch_count!=undefined)?'Done':(type==undefined)?undefined:(type=='single')?'Save':(type=='upload_csv')?(csv_uploaded==false)?undefined:'Upload':'Proceed'}/>
              </form>
            )}
          </Form>
      </div>
    )
}





function selectIndex(options, value){for(let o of options){if(o.name==value){return o.id;}}}

function valueOfField(f, workspace_field_id){
  for(let v of f.input.value){
    if(v.workspace_field_id==workspace_field_id){return v.value;}
  }
}


export default connect(ss, dd)(Add_popup)


function ss(state){
  return{
    automated_search_completed:state.companies.automated_search_completed,
    duplicate_list:state.companies.duplicates,
    companies_batch_count:state.companies.companies_batch_count,
    duplicates_batch_count:state.companies.duplicates_batch_count,
    prospect_batch_id:state.companies.uploaded_prospect_batch_id
  }
}

function dd(dispatch){
  return{
    resetDuplicateData:()=>{dispatch({type:'RESET_CSV_DATA'})},
    automatedSearch:(data)=>{dispatch({type:'REQUEST_AUTOMATED_SEARCH', payload:data});},
    createCompany:(data)=>{dispatch({type:'REQUEST_COMPANY_CREATE', payload:data});},
    dealWithDuplicates:(data)=>{dispatch({type:'REQUEST_UPDATE_BATCH_DUPLICATES', payload:data});}
  }
}
